export type { SkeletonProps } from './Skeleton'
export { Skeleton } from './Skeleton'
